module.exports = __webpack_public_path__ + "img/0.99d28757.jpg";